import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Card, Typography } from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import classNames from "classnames";
import { formatMonetary } from "utils/MathUtils";

const styles = (theme) => ({
  cardStyle: {
    padding: "5px 15px",
    display: "flex",
    flexDirection: "row" as any,
    alignItems: "center",
    minWidth: "160px",
  },
  valuesCardBox: {
    paddingLeft: "17px",
  },
  descriptionText: {
    fontSize: "11px",
    lineHeight: "13px",
    fontWeight: "400" as any,
    color: "#757575",
  },
  valueText: {
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: "700" as any,
    color: "#757575",
  },
  warningIcon: {
    color: "RGBA(255,227,71,1)",
    filter: "drop-shadow(2px 2px 2px #878787)",
    cursor: "pointer",
  },
});

const PriceCard = (props) => {
  const { Icon, title, sum, warning, onClick, classes } = props;
  return (
    <>
      <Card className={classes.cardStyle}>
        {warning ? (
          <Warning
            className={classNames(classes.icon, classes.warningIcon)}
            onClick={onClick}
          />
        ) : (
          Icon
        )}
        <div className={classes.valuesCardBox}>
          <Typography className={classes.descriptionText}>{title}</Typography>
          <Typography className={classes.valueText}>
            {formatMonetary(sum)}
          </Typography>
        </div>
      </Card>
    </>
  );
};

export default withStyles(styles)(PriceCard);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/PriceCard.tsx